import { createFileRoute, Navigate } from "@tanstack/react-router";

const Route = createFileRoute("/")({
  component: () => <Navigate to="/consent-solutions" />,
});

export { Route };
